import FirstPage from 'components/Icons/FirstPage';
import LastPage from 'components/Icons/LastPage';
import NextPage from 'components/Icons/NextPage';
import PreviousPage from 'components/Icons/PreviousPage';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Doc } from 'records/Doc';
import { Page } from 'records/Page';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps, RouteComponentProps {
  doc: Doc;
  page: Page;
}

class ViewerFooter extends React.Component<Props> {
  handleFirstPageClick = (): void => {
    const { appState, history, doc } = this.props;

    history.push(
      `/project/${appState.selectedProject}/doc/${doc.documentid}/view?page=0`
    );
  };

  handlePreviousPageClick = (): void => {
    const { appState, history, doc, page } = this.props;

    const nextPageIndex = Math.max(page.pageIndex - 1, 0);

    history.push(
      `/project/${appState.selectedProject}/doc/${doc.documentid}/view?page=${nextPageIndex}`
    );
  };

  handleNextPageClick = (): void => {
    const { appState, history, doc, page } = this.props;

    // Assuming for now that the button will be disabled if pageIndex can't be incremented.
    history.push(
      `/project/${appState.selectedProject}/doc/${doc.documentid}/view?page=${
        page.pageIndex + 1
      }`
    );
  };

  handleLastSheetClick = (): void => {
    const { appState, history, doc } = this.props;
    const { pages } = appState;

    const lastPage = pages
      .filter((p) => p.documentid === doc.documentid)
      .sortBy((p) => p.pageIndex)
      .last(new Page());

    history.push(
      `/project/${appState.selectedProject}/doc/${doc.documentid}/view?page=${lastPage.pageIndex}`
    );
  };

  render(): React.ReactNode {
    const { appState, doc, page } = this.props;
    const { pages } = appState;

    const lastPage = pages
      .filter((p) => p.documentid === doc.documentid)
      .sortBy((p) => p.pageIndex)
      .last(new Page());

    return (
      <div className=" hs3 w100 bt-1 flex justify-center shrink-0">
        <div className="row items-center justify-center fill-gray-7">
          <div
            className="mr4 fill-black-h cursor-pointer"
            onClick={this.handleFirstPageClick}
          >
            <div className="wrem-2 hrem-2 flex-center">
              <FirstPage width="22px" height="20px" />
            </div>
          </div>
          <div
            className="fill-black-h cursor-pointer"
            onClick={this.handlePreviousPageClick}
          >
            <div className="wrem-2 hrem-2 flex-center">
              <PreviousPage width="17px" height="20px" />
            </div>
          </div>
          <div className="font-size-4 color-gray-6 mx3 nowrap">
            {`${page.pageIndex + 1} of ${lastPage.pageIndex + 1}`}
          </div>
          <div
            className="mr4 fill-black-h cursor-pointer"
            onClick={this.handleNextPageClick}
          >
            <div className="wrem-2 hrem-2 flex-center">
              <NextPage width="17px" height="20px" />
            </div>
          </div>
          <div
            className="fill-black-h cursor-pointer"
            onClick={this.handleLastSheetClick}
          >
            <div className="wrem-2 hrem-2 flex-center">
              <LastPage width="22px" height="20px" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withAppStore<Props>(ViewerFooter));
